import React = require("react");
import ReactDOM = require("react-dom");
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import diyLightTheme = require("diy/material-ui/diyLightTheme");
import l10n from "diy/util/l10n";

interface DisclaimerDialogProps extends React.Props<DisclaimerDialog> {
    btnText: string;
    btnCancelText?: string;
    btnAction: () => any;
    btnCancelAction?: () => any;
}

class DisclaimerDialog extends React.Component<DisclaimerDialogProps, {}> {
    static childContextTypes: React.ValidationMap<any> = {
        muiTheme: React.PropTypes.object
    };

    getChildContext() {
        return {
            muiTheme: diyLightTheme
        };
    }

    render() {
        const actions = [
            (this.props.btnCancelText) ?
                <FlatButton
                    label={this.props.btnCancelText}
                    secondary={true}
                    onTouchTap={this.props.btnCancelAction}
                    data-test-id="disclaimer-cancel-btn"
                /> :
                null,
            <FlatButton
                label={this.props.btnText}
                primary={true}
                onTouchTap={this.props.btnAction}
                data-test-id="disclaimer-action-btn"
            />,
        ];

        return (
            <div>
                <Dialog
                    actions={actions}
                    modal={true}
                    open={true}
                    style={{ zIndex: 200002 }}
                    autoScrollBodyContent={true}
                    contentStyle={{ maxWidth: 600 }}
                    bodyStyle={{ padding: 0 }}
                >
                    {this.props.children}
                </Dialog>
            </div>
        );
    }
}

let rootEl: HTMLElement = null;

const styles = {
    title: {
        fontWeight: "bold",
        fontSize: "16px",
        marginBottom: "12px",
        textDecoration: "underline",
        textAlign: "center",
    },
    paragraph: { fontSize: "13px", margin: "6px 0px" },
    body: { padding: "24px" }
} as React.CSSProperties;

export function showDialog(btnAction: () => any, btnCancelAction: () => any) {
    rootEl = document.createElement("div");
    document.body.appendChild(rootEl);

    const messageTitle = l10n("filemanager.disclaimer.title").replace(/&amp;/, '&');
    let messageText = l10n("filemanager.disclaimer.text");
    if (jimdoData.market === 'en_CA') {
        messageText = messageText.replace(/www.ionos.com/, 'www.ionos.ca');
    }

    const btnGoText = l10n("filemanager.disclaimer.button.agree");
    const bntCancelText = l10n("filemanager.disclaimer.button.cancel");

    ReactDOM.render(
        <DisclaimerDialog
            btnText={btnGoText}
            btnAction={btnAction}
            btnCancelText={bntCancelText}
            btnCancelAction={btnCancelAction}
        >
            <div data-test-id="disclaimer-dialog-content" id="cipDisclaimer">
                <div style={styles.body}>
                    <div style={styles.title}>{messageTitle}</div>
                    <p style={styles.paragraph} dangerouslySetInnerHTML={{ __html: messageText }}></p>
                </div>
            </div>
        </DisclaimerDialog>
        ,
        rootEl);
};

export function closeDialog() {
    if (rootEl) {
        ReactDOM.unmountComponentAtNode(rootEl);
        document.body.removeChild(rootEl);
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/filemanager/sources/disclaimerDialog.tsx
 **/